"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SRC_CODE_LINK = exports.DEFAULT_WMS_IMAGE_FORMAT = exports.API_DOC_LINK = void 0;

/**
 * The Api doc link.
 * @type {string}
 */
var API_DOC_LINK = 'https://mapuiexts.github.io/react-olext.github.io/en/v0.1/apidoc/';
/**
* The Api doc link.
* @type {string}
*/

exports.API_DOC_LINK = API_DOC_LINK;
var SRC_CODE_LINK = 'https://github.com/mapuiexts/React-OlExt';
/**
 * Default WMS Image Format.
 * @type {string}
 */

exports.SRC_CODE_LINK = SRC_CODE_LINK;
var DEFAULT_WMS_IMAGE_FORMAT = 'image/png';
exports.DEFAULT_WMS_IMAGE_FORMAT = DEFAULT_WMS_IMAGE_FORMAT;